import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-text mt-1 name" }
const _hoisted_2 = { class: "p-text mt-1" }
const _hoisted_3 = {
  key: 0,
  class: "small"
}
const _hoisted_4 = {
  key: 3,
  class: "text-center"
}

import {reactive, ref, shallowRef, watch} from 'vue';
import {useSettingsStore} from '@/api/store/settings';
import {useRouter} from 'vue-router';
import moment from 'moment';
import {filesService} from '@/api/services/file';


export default /*@__PURE__*/_defineComponent({
  __name: 'DocumentForms',
  setup(__props) {

const settingsStore = useSettingsStore();
const router = useRouter();

const currentDate = moment();

const loading = ref(false);

const state = reactive({
  items: [] as any[],
  pagination: {
    meta: {},
    links: [],
    next_page_url: null,
  },
  filesLoaded: false,
  tab: 'incomplete'
});

const page = shallowRef(1)

const getFiles = (reset = false) => {
  if (reset) {
    state.items = [];
    page.value = 1;
    loading.value = true;
  }

  filesService.index({
    kind: 'form',
    page: page.value,
    completed: state.tab === 'completed' ? 1 : 0
  }).then((response) => {
    state.items.push(...response.data);
    state.pagination.meta = response.meta;
    state.pagination.links = response.links;
    state.pagination.next_page_url = response.links.next;
  }).catch((error) => {
    console.log(error);
  }).finally(() => {
    state.filesLoaded = true;
    loading.value = false;
  });
}

const toggleView = (tab: string) => {
  state.tab = tab;
  getFiles(true);
}

const seeMore = () => {
  if (state.pagination.next_page_url) {
    page.value++;
    getFiles();
  }
}

getFiles(true);

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "px-0 pb-5 document-form",
    style: {"background-color":"#F0F0F0","min-height":"500px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        class: "d-flex ga-3 pa-2",
        "no-gutters": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                class: _normalizeClass([{ 'secondary-button': state.tab === 'incomplete'}, "b-round-20 transparent"]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleView('incomplete')))
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" Incomplete ", -1)
                ]))]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                class: _normalizeClass([{ 'secondary-button': state.tab === 'completed'}, "b-round-20 transparent"]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleView('completed')))
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" Completed ", -1)
                ]))]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (loading.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(4, (n) => {
            return _createVNode(_component_v_card, {
              key: n,
              class: "mt-2 mx-2 mb-2 pa-4 border-rounded"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  class: "my-0",
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "px-3" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_skeleton_loader, {
                                  type: "text",
                                  width: "70%",
                                  class: "mb-2"
                                }),
                                _createVNode(_component_v_skeleton_loader, {
                                  type: "text",
                                  width: "40%"
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { class: "text-end px-3 d-flex align-center justify-end" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_skeleton_loader, {
                                  type: "button",
                                  width: "110"
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          }), 64))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(state.items, (document) => {
            return (_openBlock(), _createBlock(_component_v_card, {
              key: document.id,
              class: "mt-2 mx-2 mb-2 pa-4 border-rounded"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  class: "my-0",
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "px-3" }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_1, _toDisplayString(document.file_resource.title), 1),
                                _createElementVNode("p", _hoisted_2, [
                                  _createTextVNode(_toDisplayString(_unref(moment)(document.created_at).format('DD MMM YYYY')) + " ", 1),
                                  (_unref(moment)(document.created_at).isBefore(_unref(currentDate)) && state.tab === 'incomplete')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, " (Overdue) "))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_col, { class: "text-end px-3" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  class: _normalizeClass([{ 'view-button': state.tab === 'completed', 'complete-button': state.tab === 'incomplete' }, 'b-round-20']),
                                  color: _unref(settingsStore).settings.buttonColor,
                                  onClick: ($event: any) => (_unref(router).push({ name: 'form-viewer', params: { id: document.client_document.id } }))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(state.tab === 'completed' ? 'View' : 'Complete Now'), 1)
                                  ]),
                                  _: 1
                                }, 8, ["class", "color", "onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128)),
      (!loading.value && state.items.length == 0)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 2,
            class: "mt-2 mx-2 mb-2 pa-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                class: "my-0",
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { class: "py-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { class: "pt-3 px-3" }, {
                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                              _createElementVNode("p", { class: "p-text mt-1" }, "No forms available.", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (state.pagination.next_page_url)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_v_btn, {
              ripple: false,
              class: "load-more text-capitalize font-size-12-600",
              variant: "plain",
              onClick: seeMore
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode(" Load More ", -1)
              ]))]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})